export const GET_ADMIN_SCHEDULES = "GET_ADMIN_SCHEDULES"; 